import PageState from "./state";
import mutations from "./mutations";
import { getModule } from "@/store/store";
let APIS = {
  //添加/修改/删除作品
  manageVideoInfo: {
    custom: true,
    url: (data: any) => `/apis/moyin-account//moyou/activity/videoInfo`,
    headers: {
      "Content-Type": "application/json",
    },
    method: "post",
  },
  //获取作品列表
  getWorkList: {
    custom: true,
    url: (data: any) => `/apis/moyin-account/moyou/activity/videoList?bindAccountId=${data.bindAccountId}`,
    method: "get",
  }
};
export default {
  ...getModule({
    state: new PageState(),
    mutations,
    actions: {},
    APIS,
    name: "addWorkPagePage",
  }),
};
